import { Flex } from 'reflexbox';
import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const Container = styled(Flex)`
  width: 100%;
  align-items: center;
  flex-direction: column;
  padding: 50px 0;
  gap: 5px;
  min-height: 300px;
`;

export const ContainerTile = styled.span`
    font-size: 12px;
    font-weight: bold;
    color: ${colors.text['main-900']};
    padding-top: 10px;
`;

export const ContainerDescription = styled.span`
    width: 80%;
    max-width: 340px;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    color: ${colors.text['sub-500']}
`;
